import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/app.component.ts